// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2Ta_N","signatureBlock":"Footer_signatureBlock__1HEL0","signature":"Footer_signature__2LPjW"};